import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFITBooking, IFITBookingInitialState } from "./FITBookingModel";
import {
  createFITBooking,
  createFITBookingStep2,
  deleteFITBooking,
  FITBookingCancel,
  generateFITBookingByQuotationID,
  getAllFITBookings,
  getFindByIDBookingHotelVoucher,
  getFITBookingByID,
  getFITBookingDetailsForCancellation,
  sendFITBookingByEmail,
  updateFITBooking,
} from "./services/FITBooking.services";

const initialState: IFITBookingInitialState = {
  loading: false,
  error: "",
  FITBookingList: [],
  FITBookingID: null,
  IsWOBifurcation: false,
  ActiveStep: 0,
  FITAccomodationDeleteIndex: -1,
  FITTransportDeleteIndex: -1,
  FITMiscellaneousDeleteIndex: -1,
  FITSightSeenDeleteIndex: -1,
  BookingItineraryDeleteIndex: -1,
  FITBookingDetail: {
    QuotationID: null,
    ContactID: null,
    FirstName: "",
    CreatedOn: "",
    LastName: "",
    MobileNo: "",
    EmailID: "",
    Address: "",
    CityName: "",
    TravellingNo: "",
    PANCardNo: "",
    AadharNo: "",
    TermsNCondition: "",
    AccommodationCurrencyName: "",
    MiscellaneousCurrencyName: "",
    TransportaionCurrencyName: "",
    SightSeenCurrencyName: "",
    FoodOptionID: null,
    SectorID: null,
    CompanyID: null,
    TourStartDate: "",
    NoOfNights: null,
    TourEndDate: "",
    TotalNoOfRooms: null,
    TotalAdults: null,
    TotalCWB: null,
    TotalCNB: null,
    PickUpPlace: "",
    PickUpDate: "",
    PickUpTime: "",
    DropPlace: "",
    DropDate: "",
    DropTime: "",
    TotalAccomodation: null,
    TotalTransport: null,
    TotalMiscellinious: null,
    TotalSightSeen: null,
    AccommodationMarkup: null,
    TransportMarkup: null,
    MiscellaneousMarkup: null,
    SightSeenMarkup: null,
    TotalMarkup: null,
    DriverAllowance: null,
    TotalTax: null,
    SubTotal: null,
    DiscountAmt: null,
    GSTPer: null,
    GSTAmt: null,
    isTCS: false,
    TCSAmt: null,
    GrandTotal: null,
    Type: "",
    Accommodations: [],
    Transportations: [],
    Miscellaneous: [],
    SightSeen: [],
    TourItinerary: [],
    CompanyDetails: {
      CompanyName: "",
      CityName: "",
      StateName: "",
      CountryName: "",
      Address: "",
      CityID: null,
      StateID: null,
      CountryID: null,
      Pincode: "",
      OwnerName: "",
      MobileNo: "",
      EmailID: "",
      PANNo: "",
      GSTNo: "",
      AadharNo: "",
      BankName: "",
      BankBranch: "",
      BankAddress: "",
      BankAccountNo: "",
      BankIFSCCode: "",
      CompanyLogo: "",
      IsActive: 1,
      IsDefault: false,
    },
    AccommodationConversionRate: 1,
    TransportaionConversionRate: 1,
    MiscellaneousConversionRate: 1,
    SightSeenConversionRate: 1,
    AccommodationCurrencyID: 1,
    TransportaionCurrencyID: 1,
    MiscellaneousCurrencyID: 1,
    SightSeenCurrencyID: 1,
    CancelledAmount: 0,
    CNAmount: 0,
    TotalPaidAmount: 0,
  },
  FITBookingFilterDetails: {
    QuotationID: null,
    TourBookingNo: "",
    BookingDate: "",
    FirstName: "",
    MobileNo: "",
    EmailID: "",
    SectorName: "",
    filterDateType: null,
    filterFromDate: "",
    filterToDate: "",
  },
  FITBookingDetailForCancellation: {},
  FITBookingHotelVoucherDetail: {},
};

const FITBookingSlice = createSlice({
  name: "FITBooking",
  initialState,
  reducers: {
    clearFITBookingDetail: (state) => {
      state.FITBookingDetail = initialState.FITBookingDetail;
    },
    setFITBookingDetail: (state, action) => {
      state.FITBookingDetail = action.payload;
    },
    setFITBookingPaymentBifurcation: (state, action) => {
      state.IsWOBifurcation = action.payload;
    },
    setFITBookingID: (state, action) => {
      state.FITBookingID = action.payload;
    },
    clearFITBookingID: (state) => {
      state.FITBookingID = initialState.FITBookingID;
    },
    setFITAccomodationDeleteIndex: (state, action) => {
      state.FITAccomodationDeleteIndex = action.payload;
    },
    setFITTransportDeleteIndex: (state, action) => {
      state.FITTransportDeleteIndex = action.payload;
    },
    setFITMiscellaneousDeleteIndex: (state, action) => {
      state.FITMiscellaneousDeleteIndex = action.payload;
    },
    setFITSightSeenDeleteIndex: (state, action) => {
      state.FITSightSeenDeleteIndex = action.payload;
    },
    // setTourItineraryDeleteIndex: (state, action) => {
    //   state.TourItineraryDeleteIndex = action.payload;
    // },
    setFITBookingFilterDetails: (state, action) => {
      state.FITBookingFilterDetails = action.payload;
    },
    clearFITBookingFilterDetails: (state) => {
      state.FITBookingFilterDetails = initialState.FITBookingFilterDetails;
    },
    setActiveStep: (state, action) => {
      state.ActiveStep = action.payload;
    },
    clearActiveStep: (state) => {
      state.ActiveStep = initialState.ActiveStep;
    },
    increaseActiveStep: (state) => {
      state.ActiveStep = state.ActiveStep + 1;
    },
    decreaseActiveStep: (state) => {
      state.ActiveStep = state.ActiveStep - 1;
    },
    setTourItineraryDeleteIndex: (state, action) => {
      state.BookingItineraryDeleteIndex = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllFITBookings.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllFITBookings.fulfilled,
      (state, action: PayloadAction<IFITBooking[]>) => {
        state.loading = false;
        state.FITBookingList = action.payload || [];
      }
    );
    builder.addCase(getAllFITBookings.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.FITBookingList = [];
    });

    builder.addCase(createFITBooking.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createFITBooking.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createFITBooking.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateFITBooking.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateFITBooking.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateFITBooking.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteFITBooking.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteFITBooking.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteFITBooking.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getFITBookingByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getFITBookingByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.FITBookingDetail = action.payload;
    });
    builder.addCase(getFITBookingByID.rejected, (state, action) => {
      state.loading = false;
      state.FITBookingDetail = initialState.FITBookingDetail;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getFITBookingDetailsForCancellation.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getFITBookingDetailsForCancellation.fulfilled,
      (state, action: any) => {
        state.loading = false;
        state.FITBookingDetailForCancellation = action.payload;
      }
    );
    builder.addCase(
      getFITBookingDetailsForCancellation.rejected,
      (state, action) => {
        state.loading = false;
        state.FITBookingDetailForCancellation =
          initialState.FITBookingDetailForCancellation;
        state.error = action.error.message || "Something went wrong";
      }
    );

    builder.addCase(generateFITBookingByQuotationID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(generateFITBookingByQuotationID.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(
      generateFITBookingByQuotationID.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      }
    );

    builder.addCase(FITBookingCancel.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(FITBookingCancel.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(FITBookingCancel.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(sendFITBookingByEmail.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(sendFITBookingByEmail.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(sendFITBookingByEmail.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(createFITBookingStep2.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createFITBookingStep2.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createFITBookingStep2.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getFindByIDBookingHotelVoucher.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getFindByIDBookingHotelVoucher.fulfilled,
      (state, action: any) => {
        state.loading = false;
        state.FITBookingHotelVoucherDetail = action.payload;
      }
    );
    builder.addCase(
      getFindByIDBookingHotelVoucher.rejected,
      (state, action) => {
        state.loading = false;
        state.FITBookingHotelVoucherDetail =
          initialState.FITBookingHotelVoucherDetail;
        state.error = action.error.message || "Something went wrong";
      }
    );
  },
});

export const {
  setFITBookingDetail,
  clearFITBookingDetail,
  clearFITBookingID,
  setFITBookingID,
  setFITBookingPaymentBifurcation,
  setFITAccomodationDeleteIndex,
  setFITTransportDeleteIndex,
  setFITMiscellaneousDeleteIndex,
  setFITSightSeenDeleteIndex,
  setFITBookingFilterDetails,
  clearFITBookingFilterDetails,
  setActiveStep,
  clearActiveStep,
  increaseActiveStep,
  decreaseActiveStep,
  setTourItineraryDeleteIndex,
} = FITBookingSlice.actions;
export default FITBookingSlice.reducer;
